export const loginMsalHookReducerInitialState = {
  token: '',
  isLoadingToken: true,
  calledInit: false,
  loginError: false,
  needOtpCode: false,
  needToChoosePDV: false,
  callingInit: false,
  noSessionAvailable: false,
};

const loginMsalHookReducer = (state, action) => {
  switch (action.type) {
    case 'SET_TOKEN':
      return { ...state, token: action.payload };
    case 'SET_LOADING':
      return { ...state, isLoadingToken: action.payload };
    case 'SET_CALLED_INIT':
      return { ...state, calledInit: action.payload };
    case 'SET_LOGIN_ERROR':
      return { ...state, loginError: action.payload };
    case 'SET_NEED_OTP_CODE':
      return { ...state, needOtpCode: action.payload };
    case 'SET_NEED_TO_CHOOSE_PDV':
      return { ...state, needToChoosePDV: action.payload };
    case 'SET_NO_SESSION_AVAILABLE':
      return { ...state, noSessionAvailable: action.payload };
    case 'SET_CALLING_INIT':
      return { ...state, callingInit: action.payload };
    case 'ALL_READY':
      return {
        ...state,
        needOtpCode: false,
        calledInit: true,
        loginError: false,
        noSessionAvailable: false,
        callingInit: false,
      };
    default:
      return state;
  }
};

export default loginMsalHookReducer;
